module.exports = __webpack_public_path__ + "static/img/no-data-table.a0ec892.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/no-data-table.png
// module id = kdXB
// module chunks = 58